import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {User} from "../../modele/user/userModel";
import {NGXLogger} from "ngx-logger";
import {Observable} from "rxjs";
import {UserService} from "../../services/user.service";
import {ApiService} from "../../api.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-debug',
    templateUrl: './debug.component.html',
    styleUrls: ['./debug.component.scss']
})
export class DebugComponent implements OnInit, OnChanges {
    private lp = this.constructor.name;
    public user:User = new User();
    public user_name: string;
    public haveUserFromCookie: boolean = false;
    public bla:string = "";

    constructor(private logger: NGXLogger,
                public userService: UserService,
                // public apiService: ApiService,
                private route:Router,
                private actRoute:ActivatedRoute
    ) {

        this.haveUserFromCookie = this.userService.haveValidUserInService();
        this.user = this.userService.getUserForComponent();

        // this.user = this.actRoute.snapshot.data['user'];
        this.logger.info(this.lp,"cons called -> have user from cookie:",this.haveUserFromCookie, "user:",this.actRoute.snapshot.data['user']);
        // if(this.haveUserFromCookie === true){
        //     if(this.user != null){
        //         this.logger.info(this.lp,"user behind cookie:", this.user.user_name);
        //         this.logger.info(this.lp,"user behind cookie:", Object.keys(this.user));
        //         this.user_name = this.user.user_name;
        //     } else {
        //         this.logger.info(this.lp,"user behind cookie: unresolved at current time");
        //     }
        //
        // }

        // this.userService.getUserForComponentAsObservable().subscribe(user => {
        //     this.logger.info(this.lp,"got user from userservice:",user);
        //     this.user = user;
        // });

        // this.apiService.getUser().subscribe(user => {
        //     this.user = user;
        // });

        this.userService.getUserSubject().subscribe(user => {
            this.logger.info(this.lp,"service provided user:",user);
            this.user = user;
        });


        // this.userService.getUserEmitter().subscribe(user => {
        //     this.logger.info(this.lp, "have user via service:", user)
        //     this.user = user;
        // });

    }

    ngOnInit(): void {
        this.logger.info(this.lp,"ngOnInit called",
            this.userService.haveValidUserInService(),
            this.userService.getUserForComponent(),
            "user:",this.user
        );
        // this.logger.info(this.lp, "have user:", this.user.user_name, this.userService.getUserFromService())
        // let userFromService = this.userService.getUserForComponent();
        // if(userFromService != null){
        //     this.user = userFromService;
        // }
        // this.userService.createUserSessionFromToken().subscribe(createdSessionFromToken => {
        //     this.logger.info(this.lp,"have session from cookie:", createdSessionFromToken)
        // });
    }

    ngOnChanges(): void {
        this.logger.info(this.lp, "have change",this.userService.haveValidUserInService(),this.userService.getUserForComponent());
        // this.userService.haveUserInServiceAndRedirect();
    }

    getUserFromService(){
        this.userService.getUserForComponent();
    }

}
